export let AppointmentsFeatureId = /*#__PURE__*/function (AppointmentsFeatureId) {
  AppointmentsFeatureId["APPOINTMENTS_FREE"] = "APPOINTMENTS_FREE";
  AppointmentsFeatureId["APPOINTMENTS_PLUS"] = "APPOINTMENTS_PLUS";
  AppointmentsFeatureId["APPOINTMENTS_PREMIUM"] = "APPOINTMENTS_PREMIUM";
  AppointmentsFeatureId["APPOINTMENTS_AUTOMATED_DIGITAL_CONTRACTS"] = "APPOINTMENTS_AUTOMATED_DIGITAL_CONTRACTS";
  AppointmentsFeatureId["APPOINTMENTS_CONFIRMATIONS"] = "APPOINTMENTS_CONFIRMATIONS";
  AppointmentsFeatureId["APPOINTMENTS_DAILY_RESERVATION_LIMIT"] = "APPOINTMENTS_DAILY_RESERVATION_LIMIT";
  AppointmentsFeatureId["APPOINTMENTS_GOOGLE_CALENDAR_SYNC"] = "APPOINTMENTS_GOOGLE_CALENDAR_SYNC";
  AppointmentsFeatureId["APPOINTMENTS_MULTI_STAFF_RESERVATIONS"] = "APPOINTMENTS_MULTI_STAFF_RESERVATIONS";
  AppointmentsFeatureId["APPOINTMENTS_NO_SHOW_PROTECTION"] = "APPOINTMENTS_NO_SHOW_PROTECTION";
  AppointmentsFeatureId["APPOINTMENTS_PROCESSING_TIME"] = "APPOINTMENTS_PROCESSING_TIME";
  AppointmentsFeatureId["APPOINTMENTS_RESOURCE_MANAGEMENT"] = "APPOINTMENTS_RESOURCE_MANAGEMENT";
  AppointmentsFeatureId["APPOINTMENTS_WAITLIST"] = "APPOINTMENTS_WAITLIST";
  AppointmentsFeatureId["APPOINTMENTS_REPORTING"] = "APPOINTMENTS_REPORTING";
  AppointmentsFeatureId["APPOINTMENTS_CLASS_BOOKING"] = "APPOINTMENTS_CLASS_BOOKING";
  AppointmentsFeatureId["APPOINTMENTS_SMS_TEMPLATING"] = "APPOINTMENTS_SMS_TEMPLATING";
  AppointmentsFeatureId["APPOINTMENTS_API_WRITES"] = "APPOINTMENTS_API_WRITES";
  AppointmentsFeatureId["APPOINTMENTS_CUSTOMER_BLOCKING"] = "APPOINTMENTS_CUSTOMER_BLOCKING";
  AppointmentsFeatureId["APPOINTMENTS_CUSTOMER_FIELDS"] = "APPOINTMENTS_CUSTOMER_FIELDS";
  AppointmentsFeatureId["APPOINTMENTS_SERVICE_COST"] = "APPOINTMENTS_SERVICE_COST";
  AppointmentsFeatureId["APPOINTMENTS_CREDIT_PACKAGE"] = "APPOINTMENTS_CREDIT_PACKAGE";
  AppointmentsFeatureId["COMMISSION_TRACKING"] = "COMMISSION_TRACKING";
  AppointmentsFeatureId["CONTRACTS_CUSTOM_FIELDS"] = "CONTRACTS_CUSTOM_FIELDS";
  AppointmentsFeatureId["EMPLOYEE_MANAGEMENT"] = "EMPLOYEE_MANAGEMENT";
  return AppointmentsFeatureId;
}({});
export let AppointmentsClientSideFeatureId = /*#__PURE__*/function (AppointmentsClientSideFeatureId) {
  AppointmentsClientSideFeatureId["UNLIMITED_STAFF_ACCOUNTS"] = "UNLIMITED_STAFF_ACCOUNTS";
  AppointmentsClientSideFeatureId["ONLINE_BOOKING_SITE"] = "ONLINE_BOOKING_SITE";
  AppointmentsClientSideFeatureId["REMINDERS"] = "REMINDERS";
  AppointmentsClientSideFeatureId["SOCIAL_MEDIA_INTEGRATIONS"] = "SOCIAL_MEDIA_INTEGRATIONS";
  AppointmentsClientSideFeatureId["INTEGRATED_PAYMENTS"] = "INTEGRATED_PAYMENTS";
  AppointmentsClientSideFeatureId["MULTIPLE_LOCATIONS"] = "MULTIPLE_LOCATIONS";
  AppointmentsClientSideFeatureId["ADVANCED_STAFF_MANAGEMENT"] = "ADVANCED_STAFF_MANAGEMENT";
  AppointmentsClientSideFeatureId["CUSTOM_PRICING"] = "CUSTOM_PRICING";
  AppointmentsClientSideFeatureId["DISCOUNTED_PROCESSING_RATE"] = "DISCOUNTED_PROCESSING_RATE";
  AppointmentsClientSideFeatureId["APPOINTMENTS_REPORTING_TEAM_PERFORMANCE"] = "APPOINTMENTS_REPORTING_TEAM_PERFORMANCE";
  AppointmentsClientSideFeatureId["APPOINTMENTS_REPORTING_FUTURE_BOOKINGS"] = "APPOINTMENTS_REPORTING_FUTURE_BOOKINGS";
  return AppointmentsClientSideFeatureId;
}({});
export const APPOINTMENTS_LEGACY_TOKEN = 'appointments';
export let AppointmentsPlanToken = /*#__PURE__*/function (AppointmentsPlanToken) {
  AppointmentsPlanToken["APPOINTMENTS_FREE_TOKEN"] = "appointments-free";
  AppointmentsPlanToken["APPOINTMENTS_PLUS_TOKEN"] = "appointments-plus";
  AppointmentsPlanToken["APPOINTMENTS_PREMIUM_TOKEN"] = "appointments-premium";
  return AppointmentsPlanToken;
}({});